import { getWidget } from '@plone/volto/helpers/Widget/utils';
import { default as ErrorBoundary } from '@plone/volto/components/theme/Error/ErrorBoundary';
import { FormattedMessage } from 'react-intl';

import { Grid } from 'semantic-ui-react';
import config from '@plone/volto/registry';
export const UserData = ({ userschema, user }) => {
  const { views } = config.widgets;
  return (
    <>
      <h4>
        <FormattedMessage
          id="User information"
          defaultMessage="User information"
        />
      </h4>
      <br />
      <Grid className="user-data" stackable>
        {userschema.loaded &&
          userschema.userschema.fieldsets[0].fields.map((f, key) => {
            let field = {
              ...userschema.userschema?.properties[f],
              id: f,
              widget: getWidget(f, userschema.userschema?.properties[f]),
            };
            let Widget = views?.getWidget(field);
            return f !== 'title' ? (
              <Grid.Row className="user-data-row">
                <Grid.Column width={4} className="user-data-label">
                  <span>{field.title}:</span>
                </Grid.Column>
                <Grid.Column width={8} className="user-data-value">
                  <ErrorBoundary name={f}>
                    <Widget value={user[f]} />
                  </ErrorBoundary>
                </Grid.Column>
              </Grid.Row>
            ) : (
              <Widget key={key} value={user[f]} />
            );
          })}
      </Grid>
      <h4>
        <FormattedMessage
          id="User company information"
          defaultMessage="User company information"
        />
      </h4>
      <br />
      <Grid className="user-data" stackable>
        {userschema.loaded &&
          userschema.userschema.fieldsets[1].fields.map((f, key) => {
            let field = {
              ...userschema.userschema?.properties[f],
              id: f,
              widget: getWidget(f, userschema.userschema?.properties[f]),
            };
            let Widget = views?.getWidget(field);
            return f !== 'title' ? (
              <Grid.Row className="user-data-row">
                <Grid.Column width={4} className="user-data-label">
                  <span>{field.title}:</span>
                </Grid.Column>
                <Grid.Column width={8} className="user-data-value">
                  <ErrorBoundary name={f}>
                    <Widget value={user[f]} />
                  </ErrorBoundary>
                </Grid.Column>
              </Grid.Row>
            ) : (
              <Widget key={key} value={user[f]} />
            );
          })}
      </Grid>
    </>
  );
};
